import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import DigilockerCallbackService from "@/services/NPS/Stepper/APIs/digilockerCallback";
import navigationRoutes from "@/utils/navigationRoutes";
import { Spin } from "antd";
import { notify } from "@/components/common/Notification";
const DigilockerCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      const code = searchParams.get("code");
      const state = searchParams.get("state");
      const error = searchParams.get("error");

      // Handle authorization error
      if (error) {
        console.error("❌ Digilocker authorization error:", error);
        notify.error(error);
        navigate(navigationRoutes.NEW_SUBSCRIBER_REGISTRATION); // navigate after error
        return;
      }

      // Handle success with code
      if (code && state) {
        try {
          console.log("📤 Exchanging authorization code...");
          await DigilockerCallbackService.digilockerCallback(code ?? "");
          console.log("🎉 Digilocker connected successfully!");
          notify.success("Digilocker verified successfully!");
          // Success message

          // If opened in popup, send message to parent and close
          if (window.opener) {
            window.opener.postMessage(
              {
                type: "DIGILOCKER_CALLBACK",
                code,
                state,
                success: true,
              },
              window.location.origin
            );
            window.close();
          } else {
            // If opened in main window, navigate to homepage
            navigate(navigationRoutes.NEW_SUBSCRIBER_REGISTRATION);
          }
        } catch (error) {
          console.error("❌ Failed to exchange code:", error);
          notify.error("Failed to exchange code. Please try again.");
          navigate(navigationRoutes.NEW_SUBSCRIBER_REGISTRATION); // navigate after failure
        }
      } else {
        // Missing required parameters
        console.error("❌ Missing code or state parameters");
        notify.error("Missing code or state parameters.");
        navigate(navigationRoutes.NEW_SUBSCRIBER_REGISTRATION);
      }
    };

    handleCallback();
  }, [searchParams, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="text-center">
        <Spin size="large" />
        <p className="mt-4 text-lg text-white">Connecting to DigiLocker...</p>
      </div>
    </div>
  );
};

export default DigilockerCallbackPage;
